import { Palette } from '@material-ui/core/styles/createPalette'
import { TypographyOptions } from '@material-ui/core/styles/createTypography'

/*
CSS Font Weights
100	Thin (Hairline)
200	Extra Light (Ultra Light)
300	Light
400	Normal (Regular)
500	Medium
600	Semi Bold (Demi Bold)
700	Bold
800	Extra Bold (Ultra Bold)
900	Black (Heavy)
950	Extra Black (Ultra Black)
*/

export default (palette: Palette): TypographyOptions => ({
  fontFamily: ['Union', 'Arial', 'sans-serif'].join(','),
  h1: {
    fontSize: '2.25rem',
    letterSpacing: '-0.0375rem',
    lineHeight: '2.625rem',
    fontWeight: 'bold',
  },
  h2: {
    fontSize: '1.375rem',
    letterSpacing: '-0.0375rem',
    lineHeight: '1.75rem',
    fontWeight: 'bold',
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: '1.375rem',
  },
  h4: {
    fontSize: '0.875rem',
  },
  subtitle1: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  body1: {
    fontSize: '0.875rem',
    letterSpacing: 0,
    lineHeight: '1.125rem',
  },
  body2: {
    fontSize: '0.8rem',
    letterSpacing: 0,
    lineHeight: '1rem',
  },
  // TODO: set up custom typography types with more established style guide
  button: {
    fontSize: '0.9375rem',
    letterSpacing: '0rem',
    lineHeight: '1.125rem',
  },
})
